export default __webpack_public_path__ + "51d33f98216de39dd76727cf8207c9ba.svg";